// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/es6.number.min-safe-integer.js
// module id = 1251
// module chunks = 168707334958949